import React from 'react';
import '../styles/LogoSection.css';

// Updated logo URLs - keeping working ones (Emirates, Airbnb, Visa)
const logoImages = [
  { id: 1, src: 'https://cf.bstatic.com/static/img/bcom_logo_blue_bg/f12f834e849b2a7f752a14b2598a6ddfeda1e713.svg', alt: 'Booking.com' },
  { id: 2, src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Emirates_logo.svg/1200px-Emirates_logo.svg.png', alt: 'Emirates' },
  { id: 3, src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Marriott_hotels_logo14.svg/2560px-Marriott_hotels_logo14.svg.png', alt: 'Marriott' },
  { id: 4, src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Airbnb_Logo_B%C3%A9lo.svg/2560px-Airbnb_Logo_B%C3%A9lo.svg.png', alt: 'Airbnb' },
  { id: 5, src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/TripAdvisor_Logo.svg/2560px-TripAdvisor_Logo.svg.png', alt: 'TripAdvisor' },
  { id: 6, src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/TripAdvisor_Logo.svg/2560px-TripAdvisor_Logo.svg.png', alt: 'Expedia' },
  { id: 7, src: 'https://1000logos.net/wp-content/uploads/2023/03/Hertz-logo.png', alt: 'Hertz' },
  { id: 8, src: 'https://1000logos.net/wp-content/uploads/2021/11/VISA-logo.png', alt: 'Visa' },
];

const LogoSection = () => {
  return (
    <section className="logo-section">
      <div className="container">
        <h2 className="section-title">Our Trusted Partners</h2>
        <div className="logo-slider">
          <div className="logo-slide-track">
            {/* First set of logos */}
            {logoImages.map((logo) => (
              <div className="logo-slide" key={logo.id}>
                <img src={logo.src} alt={logo.alt} />
              </div>
            ))}
            
            {/* Duplicate set for continuous scrolling effect */}
            {logoImages.map((logo) => (
              <div className="logo-slide" key={`duplicate-${logo.id}`}>
                <img src={logo.src} alt={logo.alt} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoSection;
